const roomCategories = [
    {
        key: 0,
        name: "All Rooms",
        link: "products",
    },
    {
        key: 1,
        name: "Living Room",
        link: "products",
    },
    {
        key: 2,
        name: "Bathroom",
        link: "products",
    },
    {
        key: 3,
        name: "Bedroom",
        link: "products",
    },
    {
        key: 4,
        name: "Dining",
        link: "products",
    },
    {
        key: 5,
        name: "Kitchen",
        link: "products",
    },
    {
        key: 6,
        name: "Laundry",
        link: "products",
    },
    {
        key: 7,
        name: "Balcony",
        link: "products",
    },
    {
        key: 8,
        name: "Home Office",
        link: "products",
    },
]

export default roomCategories;